import React from 'react';
import PropTypes from 'prop-types';

import './TermsAndConditions.scss';

export default function TermsAndConditions(props) {
  const { brand: { primaryColor } = {} } = props;

  return (
    <div className="c-terms-and-conditions">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <h1>Delegate Terms and Conditions</h1>

            <p>
              These terms and conditions apply between the person, firm, company
              or other entity specified on your booking form ("
              <strong>you</strong>" or "<strong>your</strong>") and the Informa
              Group company that is the owner, organizer, operator and/or
              manager of the event/conference ("<strong>Informa</strong>"), for
              attendee / delegate registrations for the event specified on your
              booking form ("<strong>Event</strong>"). Please read them
              carefully as they contain important information. By submitting
              your registration to attend the Event ("
              <strong>your registration</strong>") you agree to be bound by
              these terms to the exclusion of all other terms. If you do not
              agree to be bound by these terms Informa will be unable to accept
              your registration.
            </p>

            <ol>
              <li>
                <strong>Registration Confirmation</strong>
                <br />
                <br />
                Your registration (whether submitted directly by you or on your
                behalf) is an offer to Informa to attend an Event which is
                subject to Informa's acceptance in writing (which may include
                (without limitation) email). A binding contract between Informa
                and you will only be formed when written confirmation of
                acceptance ("<strong>Confirmation</strong>" or "
                <strong>Confirmed</strong>") is sent by Informa to you (whether
                or not it is received) using the contact details you provided at
                the time of registration. You should contact Informa if you have
                not received Confirmation within 5 days of your registration,
                but in any event if Confirmation is not sent within 14 days of
                Informa receiving your registration, your registration will be
                deemed to be accepted unless Informa notifies you otherwise.
                Informa reserves the right in its sole discretion to refuse to
                accept your registration.
              </li>
              <li>
                <strong>Fees and Payment Terms</strong>
                <ol>
                  <li>
                    You will pay Informa the fees specified in your booking form
                    for the Event ("<strong>your fees</strong>"). Payment of
                    your fees must be received in full and in cleared funds by
                    Informa from you in accordance with Informa's payment terms
                    from time to time in force but in any event not later than
                    48 hours before the Event. If payment of your fees in full
                    is not received before the Event, Informa may (at its sole
                    discretion) either require such payment as a condition of
                    your access to the Event or refuse or block your access to
                    the Event (whether physical or virtual). No refunds of any
                    proportion of your fees already paid (if any) will be made
                    and any balance of your fees will remain due and payable
                    where access to an Event is refused under this Condition
                    2.1.
                  </li>
                  <li>
                    All discounts can only be applied at the time of
                    registration and discounts cannot be combined. All discounts
                    are subject to Informa's approval. Discounts for group
                    registrations are only valid for the number of delegates
                    specified on your booking form. If the number of delegates
                    that actually attends the Event is (for any reason) less
                    than the number specified in your booking form, then Informa
                    may (at its sole discretion) change your fees to reflect the
                    number of delegates that actually attend the Event in line
                    with Informa's published prices then in force. Any
                    additional sums payable to us as a result shall be paid in
                    line with this Condition 2.
                  </li>
                  <li>
                    Prices for each Event are correct at the time of
                    publication. Informa reserves the right to change the prices
                    at any time but changes will not affect registrations which
                    have already been confirmed by Informa.
                  </li>
                  <li>
                    It is the intent of the parties that Informa will receive
                    payment of your fees net of all applicable taxes, including
                    without limitation, sales, VAT, service or withholding taxes
                    ("<strong>Taxes</strong>"), all of which shall be paid
                    solely by you. If and to the extent that any Taxes are
                    levied upon, or found to be applicable to, the whole or any
                    portion of the payment of your fees, the amount of such
                    payment shall be increased by an amount necessary to
                    compensate for the Taxes (including any amount necessary to
                    "gross up" for Taxes levied on the increase itself).
                  </li>
                </ol>
              </li>
              <li>
                <strong>Cancellation by You</strong>
                <ol>
                  <li>
                    Except as may be otherwise expressly advised as part of the
                    particular Event’s registration process, you may cancel your
                    registration in accordance with this Condition 3. You will
                    receive a refund of your fees paid to Informa (if any) if
                    you cancel your registration 57 days or more before the
                    Event, subject to an administration charge equivalent to 10%
                    of the total amount of your fees plus Taxes (if applicable).
                    The Company regrets that the full amount of your fee remains
                    payable in the event that your cancellation is 56 days or
                    less before the Event or if you fail to attend the Event. If
                    a cancellation changes the entitlement to a
                    multi-registration discount, the lowest value registration
                    will be cancelled first. No cancellations are accepted once
                    any part of a single or multi registration party has
                    accessed the pre-Event networking or partnering facilities,
                    applications or platforms. All cancellations must be sent by
                    email to{' '}
                    <a
                      className="termsAndConditionsEmail"
                      href="mailto:connect.cancellations@informa.com"
                      style={{ color: primaryColor }}
                    >
                      connect.cancellations@informa.com
                    </a>{' '}
                    marked for the attention of Customer Services and must be
                    received by Informa. You acknowledge that the refund of your
                    fees in accordance with Condition 3 is your sole remedy in
                    respect of any cancellation of your registration by you and
                    all other liability is expressly excluded.
                  </li>
                  <li>
                    Substitutions with employees from your organisation are
                    welcome at any time but in all other respects delegate
                    registrations are issued for your personal use only and
                    cannot be shared with any person during the Event. You may
                    not purchase registrations as agent for any third party,
                    sell or otherwise transfer your registration to others, or
                    exploit the registration commercially or non-commercially in
                    any way.
                  </li>
                </ol>
              </li>
              <li>
                <strong>
                  Change to or Cancellation of the Event by Informa
                </strong>
                <ol>
                  <li>
                    Informa may (at its sole discretion) change the format
                    (including, without limitation, from a physical in-person
                    Event to a virtual Event and vice versa), speakers,
                    participants, content, venue location and programme or any
                    other aspect of the Event at any time and for any reason,
                    whether or not due to a Force Majeure Event, in each case
                    without liability.
                  </li>
                  <li>
                    Informa may (at its sole discretion) change the date or
                    cancel an Event at any time for any reason. Where Informa
                    changes the date or cancels the Event for any reason except
                    due to a Force Majeure Event (in which case the terms of
                    Condition 4.3 shall apply) Informa shall automatically
                    transfer your registration to any rearranged Event that
                    Informa chooses to organise (acting in its sole discretion).
                    If you promptly, and not more than 21 days after being
                    notified by Informa of the new date(s) of the Event, notify
                    Informa in writing that you do not wish to attend the
                    rearranged Event or if Informa elects not to rearrange the
                    Event then you will (as your sole remedy) be entitled, at
                    your discretion, to receive either a credit note or a refund
                    in respect of your fees received by Informa. After expiry of
                    the 21 day notification period set out above you may still
                    cancel your registration for the rearranged Event. Condition
                    3 above shall apply with reference to the new dates and an
                    administrative charge may be payable.
                  </li>
                  <li>
                    Where a Force Majeure Event has or may have (in Informa's
                    sole discretion) an adverse impact on: (i) the ability of
                    Informa to hold the Event at the planned venue or on the
                    planned date; or (ii) the Event generally, then Informa
                    shall be entitled but not obliged (in its sole discretion)
                    to either: (i) provide an alternative format, facility or
                    venue for the Event; and/or (ii) reschedule the Event. Any
                    of your fees received by Informa shall be applied to any
                    rearranged or rescheduled Event held pursuant to this
                    Condition 4.3 and you shall not be entitled to object to
                    such rearranged or rescheduled Event or have any right to
                    claim any compensation in respect thereof. If Informa is
                    unable or elects not to rearrange or reschedule the Event
                    pursuant to this Condition 4.3, then you will (as your sole
                    remedy) be entitled, in your sole discretion, to receive
                    either a refund or credit note in respect of your fees
                    received by Informa.
                  </li>
                  <li>
                    These terms and conditions shall equally apply in respect of
                    any rearranged or rescheduled Event organised by Informa
                    pursuant to Conditions 4.2 and 4.3.
                  </li>
                  <li>
                    For the purpose of these terms and conditions "
                    <strong>Force Majeure Event</strong>" means any event or
                    circumstance arising that is beyond the reasonable control
                    of Informa (including but not limited to governmental laws,
                    ordinances, regulations, requisitions, restrictions,
                    guidelines, recommendations or action, imposition of
                    sanctions, embargo, military action, acts or threats of
                    terrorism or war, mob, civil commotion or riot, health
                    scares (including without limitation, epidemic and pandemic
                    (e.g., COVID-19), whether or not new, ongoing or recurring),
                    fire, acts of God, flood, drought, earthquake, severe
                    weather, disaster, disruption to transportation, third party
                    contractor/supplier failure, venue damage or cancellation,
                    industrial dispute, strikes, labour disputes,
                    interruption/failure of utility service, lack of commodities
                    or supplies, accidents, nuclear, chemical or biological
                    contamination, speaker or participant cancellation or
                    withdrawal, or any other comparable calamity or casualty).
                  </li>
                  <li>
                    To the fullest extent permitted by the applicable law,
                    Informa shall not be liable to you for any loss, delay,
                    damage or other liability incurred resulting from or arising
                    in connection with the cancellation or date change of the
                    Event howsoever arising or any venue change. You acknowledge
                    and agree that the provisions of Conditions 4.1, 4.2 and 4.3
                    set out your sole remedy should the Event be changed,
                    postponed or cancelled and all other liability of Informa is
                    expressly excluded.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Access to and Use of an online Event Platform </strong>
                <br />
                <br />
                <span className="statement">
                  If you have access to Streamly (as defined below) included in
                  your booking form, then the terms of this Condition 5 apply to
                  your use of Streamly.
                </span>
                <ol>
                  <li>
                    You undertake to be responsible for any technical
                    requirements needed to enable you to access the Event
                    website, app or other platform provided to you in relation
                    to an Informa product or service, which may include
                    Informa’s Streamly video streaming service platform
                    available at https://streamly.video/ ("
                    <strong>Streamly</strong>") which hosts multimedia
                    recording(s) of the Event and other non-Event related
                    content available for on-demand video streaming and may
                    include “partneringONE™” and/or “partneringONEplus™” (a
                    business-to-business platform product that acts as a
                    community through which users can network and contact each
                    other and find potential business prospects) available to
                    attendees of Events within the life sciences vertical
                    organised by the EBD Group of Informa (together the “
                    <strong>Event Platform</strong>”).
                  </li>
                  <li>
                    We do not guarantee that the Event Platform will operate
                    continuously, securely or without errors or interruption,
                    and we do not accept any liability for its temporary
                    unavailability. We do not guarantee that the Event Platform
                    and/or any content thereon (including, without limitation,
                    any content available for download) will be free from
                    viruses, infections, Trojan horses, worms and/or any other
                    code that has contaminating or destructive properties.
                  </li>
                  <li>
                    You must not attempt to interfere with the proper working of
                    the Event Platform (for example, by attempting to circumvent
                    security or tamper with, hack into or otherwise disrupt any
                    computer system, server, website, router or any other
                    internet connected device).
                  </li>
                  <li>
                    You agree to comply with any website terms of use and/or
                    fair or acceptable use policies indicated on any website on
                    which the Event Platform is hosted, including but not
                    limited to{' '}
                    <a
                      href="https://informaconnect.com/terms-of-use/"
                      style={{ color: primaryColor }}
                    >
                      https://informaconnect.com/terms-of-use/
                    </a>{' '}
                    and any terms of use on{' '}
                    <a href="https://streamly.video/">www.Streamly.video</a>{' '}
                    from time to time. To the extent your Event booking includes
                    Streamly or access and membership to “partneringONE™” and/or
                    “partneringONEplus™” you/delegate(s) agree to be bound by
                    the terms of use available at
                    https://informaconnect.com/terms-of-use/ in respect of such
                    use. To the extent of any conflict between these delegate
                    terms and conditions and the terms of use available at{' '}
                    <a href="https://informaconnect.com/terms-of-use/">
                      https://informaconnect.com/terms-of-use/
                    </a>{' '}
                    the website terms of use shall govern (but only to the
                    extent of such conflict).
                  </li>
                  <li>
                    We do not endorse or accept any responsibility for the
                    content, or the use of, any goods or services that may be
                    identified or described on the Event Platform and we shall
                    not be liable for any loss or damage caused or alleged to be
                    caused by or in connection with use of, or reliance on, any
                    content, goods or services available on or through the Event
                    Platform or any website or other resource referenced
                    therein.
                  </li>
                  <li>
                    Informa may issue you with a username and password.
                    Usernames and passwords are confidential and remain the
                    property of Informa at all times and may not be sold,
                    assigned or transferred to any third party without our
                    permission. Your username and password are personal to you.
                    You hereby agree that you will not permit others to use your
                    username or password and you will be and remain liable for
                    the acts of any person using your username and password.
                  </li>
                  <li>
                    Any multimedia recording(s) or videos, posts, messages, or
                    other materials, information or data you supply or upload to
                    the Event Platform where that Event Platform is Streamly
                    will be considered non-confidential and non-proprietary, and
                    we have the right to use, copy, distribute and disclose to
                    third parties any such user generated content for any
                    purpose. You hereby waive any moral rights in any user
                    generated content to the extent permitted by applicable law.
                  </li>
                  <li>
                    Any posts, messages, or other materials, information or data
                    that you supply or upload to the Event Platform where that
                    Event Platform is “partneringONE™” and/or
                    “partneringONEplus™” will be considered proprietary to you
                    but non-confidential, save that Informa undertakes not to
                    disclose such user generated content outside of the
                    “partneringONE™” and/or “partneringONEplus™” platforms.
                    Informa shall not acquire any ownership or intellectual
                    property rights in any content or data that you input or
                    share within “partneringONE™” and/or “partneringONEplus™”.
                    You grant to Informa a non-exclusive, non-transferable
                    license to access and use the data you input into these
                    platforms, and any intellectual property rights owned by you
                    and comprised therein, for the purpose of operating,
                    promoting, and improving “partneringONE™” and/or
                    “partneringONEplus™”.
                  </li>
                  <li>
                    You shall not make libellous postings or any postings which
                    are illegal or infringe the intellectual property rights of
                    any third party. Informa will not be responsible for
                    monitoring content uploaded on the Event Platform for
                    compliance with law.
                  </li>
                  <li>
                    You may use the Streamly Event Platform for access to the
                    Event and for viewing on-demand content made available to
                    you on Streamly (to the extent access to Streamly is
                    included in your booking form). In respect of any Event
                    Platform you must not: (i) download, store, reproduce,
                    transmit, display, copy, distribute, exploit or use the
                    Event Platform and/or any content thereon for your own
                    commercial gain, (ii) use the Event Platform and/or any
                    content thereon in any manner other than in compliance with
                    law, these terms and conditions and the applicable Event
                    Platform terms and conditions, (iii) infringe our
                    intellectual property rights or those of any third party in
                    relation to your use of the Event Platform and/or any
                    content thereon, (iv) send messages, comment, upload or link
                    to any material that is reasonably considered defamatory,
                    offensive, harassing, misleading or unlawful content, (v)
                    transmit, or procure the sending of, any unsolicited or
                    unauthorised advertising or promotional material or any
                    other form of similar solicitation, and/or (vi) knowingly
                    transmit, send or upload any data that contains viruses,
                    infections, Trojan horses, worms and/or any other code that
                    has contaminating or destructive properties viruses.
                  </li>
                  <li>
                    By uploading content to the Streamly Event Platform, you
                    grant to Informa and to each user of the Streamly Event
                    Platform a worldwide, non-exclusive, royalty-free,
                    transferable, sublicensable licence to use that content
                    (including to reproduce, distribute, modify, display and
                    perform it) for the purpose of operating, promoting, and
                    improving the Streamly Event Platform. The licences granted
                    herein shall continue until such content is removed from the
                    Event Platform. Informa may use automated systems or filters
                    that analyse the uploaded Streamly content to help detect
                    infringement and abuse, such as spam, malware, and illegal
                    content. Informa reserves the right to monitor and track
                    visits to the Streamly Event Platform. If Informa reasonably
                    believes that any uploaded Streamly content (i) is in breach
                    of these Conditions or (ii) may cause harm to Informa, our
                    users, or third parties, Informa reserves the right to
                    remove or take down some or all of such uploaded Streamly
                    content but we do not have any obligation to do so. Informa
                    may operate a notice and takedown system whereby users of
                    the Streamly Event Platform may report content and request
                    its removal from the Streamly Event Platform.
                  </li>
                  <li>
                    Informa is under no obligation to oversee, monitor or
                    moderate any interactive service we provide on the Event
                    Platform and, without limitation, we expressly exclude all
                    liability for any loss, injury or damage whatsoever arising
                    from the use of any interactive service by any user, whether
                    the service is moderated or not.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Consequences for Breach</strong>
                <br />
                By registering for and attending the Event, you agree to comply
                at all times with Informa’s Code of Conduct, as may be available
                on Informa’s website from time to time.
                <br />
                <br />
                Informa may (at its sole discretion) refuse access to, or eject
                / block from the Event, any person in its absolute discretion,
                including (without limitation) any person who fails to comply
                with these terms and conditions or who in the opinion of Informa
                represents a security risk, nuisance or annoyance to the running
                of the Event. You agree to comply with all reasonable
                instructions issued by Informa or the venue owners or operators
                at the Event.
              </li>
              <li>
                <strong>
                  Consent to Official Photography and / or Recording at Events
                </strong>
                <br />
                <br />
                All unauthorised photography and / or the recording or
                transmitting of audio or visual material, data or information is
                expressly prohibited. You consent to Informa Group undertaking
                multimedia recording of the Event which may include your
                participation in the Event as a delegate (the “
                <strong>Content</strong>”) and you consent to the use by Informa
                Group of any such recording anywhere in the world for
                promotional, marketing and other purposes. You acknowledge and
                agree that Informa Group is the exclusive owner of all rights in
                the Content and hereby waive any and all: (a) rights in and to
                such Content, and (b) claims that you may have relating to or
                arising from the Content or its use.
              </li>
              <li>
                <strong>Data Privacy</strong> <br />
                <br />
                The personal information which you provide to us will be held by
                us on a database and where we have appropriate
                authorisation/justification (which may include, without
                limitation, express/implied consent or legitimate interests),
                may be shared with other companies in the Informa group and
                selected third parties in the UK, United States and
                internationally for promotional purposes. Your personal
                information may also be shared with government entities and
                regulatory authorities as required by law. Further, there may be
                certain areas of the Event at which your attendance is
                conditional on your personal information being provided to third
                parties which have sponsored or are managing such areas. The use
                that any third parties make of your personal information is
                outside of Informa’s control and, to the extent permitted by
                applicable law, we do not accept any liability in this regard.
                For more information about how Informa use the information you
                provide please see our privacy notice which can be found at{' '}
                <a
                  className="termsAndConditionsEmail"
                  href="https://www.informa.com/privacy-policy"
                  style={{ color: primaryColor }}
                >
                  https://www.informa.com/privacy-policy/
                </a>
                .
              </li>
              <li>
                <strong>Limitation of Liability</strong>
                <br />
                <br />
                To the fullest extent permitted by the applicable law, Informa
                excludes: (a) all liability for loss, injury or damage to
                persons or property at the Event; (b) all indemnities,
                warranties, representations (whether express or implied); and
                (c) any actual or alleged indirect loss or consequential loss,
                any loss of profits, anticipated profits, savings, loss of
                business revenue, loss of business, loss of opportunity, loss of
                goodwill, or any other type of economic loss, suffered by you
                howsoever arising. If Informa is liable to you for any reason,
                Informa's total liability to you in relation to the Event
                (whether under these terms or conditions or otherwise) is
                limited to the amount of your fees received by Informa.
              </li>
              <li>
                <strong>Miscellaneous</strong>
                <ol>
                  <li>
                    If, by reason of any Force Majeure Event, Informa is delayed
                    in or prevented from performing any of its obligations to
                    you under these terms and conditions or otherwise, then such
                    delay or non-performance shall not be deemed to be a breach
                    of these terms and conditions and no loss or damage shall be
                    claimed by you by reason thereof. Informa's obligations
                    shall be suspended during the period of the delay or
                    non-performance and Informa and you shall each use
                    reasonable endeavours to mitigate the effect of the Force
                    Majeure Event. The provisions of this Condition 10.1 are
                    subject to the provision of Condition 4.3.
                  </li>
                  <li>
                    Informa reserves the right to amend these terms and
                    conditions from time to time. However, you will be subject
                    to the terms and conditions in force at the time you submit
                    your registration.
                  </li>
                  <li>
                    No person other than you and Informa shall have the right to
                    enforce these terms and conditions between us without the
                    prior written agreement of you and Informa.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Governing Law and Jurisdiction</strong>
                <br />

                <ol>
                  <li>
                    The governing law of these terms and conditions shall be
                    determined based on the location of in which the Event is
                    due to take place:
                    <ol className="type-letter-list">
                      <li>
                        If the Event is originally scheduled to be held in the
                        United States, then these terms and conditions are
                        governed by the laws of the State of New York (without
                        application of conflicts of laws principles) and you
                        submit to the exclusive jurisdiction of the federal and
                        state courts located in New York County, NY, having
                        appropriate subject matter jurisdiction; or
                      </li>
                      <li>
                        If the Event is originally scheduled to be held in the
                        United Arab Emirates, then these terms and conditions
                        and any dispute or claim arising out of or in connection
                        with it or its subject matter or formation shall be
                        governed by and construed in accordance with the laws of
                        Dubai and such federal laws of the UAE as are applicable
                        in Dubai and you submit to the exclusive jurisdiction of
                        the courts of Dubai; or
                      </li>
                      <li>
                        If the Event is originally scheduled to be held in
                        Canada, then these terms and conditions are governed by
                        the laws of the Province of Ontario, Canada, exclusive
                        of the choice of law rules of any jurisdiction, and you
                        agree to submit to the exclusive jurisdiction of the
                        courts located in Toronto, Ontario having subject matter
                        jurisdiction.
                      </li>
                      <li>
                        Otherwise, these terms and conditions and any dispute or
                        claim arising out of or in connection with it or its
                        subject matter or formation shall be governed by English
                        law and you submit to the exclusive jurisdiction of the
                        English courts.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Nothing in this Condition 11 shall prevent or restrict
                    Informa from pursuing any action against you in any court of
                    competent jurisdiction.
                  </li>
                </ol>
              </li>
            </ol>

            <p>
              <strong>DISCLAIMER FOR ACTIVITIES</strong>
            </p>

            <p>
              You should consider carefully whether or not you will be able to
              participate in any activities offered as part of a programme
              relating to the Event. Informa warns that some activities may be
              physically demanding and/or carry inherent dangers. You understand
              that some exercise-based activities may be a risk to your physical
              health and safety if you do not perform them correctly. You accept
              that, if a programme exists for the Event you are attending, it is
              entirely your responsibility to decide whether or not
              participation in any activity offered as part of the programme is
              appropriate to your capabilities, aptitude, fitness and health. If
              you have any concerns about your capabilities, aptitude, fitness
              and/or health to participate you should consult with (and follow
              the recommendations of) a medical professional prior to engaging
              in any activity. If at any time during any activity you feel
              unwell or consider that it is unsafe for you to continue, please
              stop the activity immediately and seek appropriate advice. You
              also accept that it is entirely your responsibility to observe all
              health and safety requirements and instructions that you may be
              given in relation to activities. If you are participating in any
              activity that is offered virtually for participation in a home or
              office environment, you should ensure that your environment is
              safe, provides adequate space and is free of dangerous or
              hazardous objects and materials. To the extent permitted by
              applicable law, Informa and all entities within the Informa group
              (as well as any employees or other representatives of the same)
              excludes all liability for any loss, injury or damage whatsoever
              that you may suffer in connection with or arising from your
              participation in any activities offered as part of the programme
              (including, without limitation, any activities held outside of, or
              incidentally to, the main Event that you are attending), whether
              direct, indirect, consequential, special, incidental or punitive
              loss, injury or damage (including, without limitation, injury to
              persons, property damage, theft, loss of profits, loss of
              business, loss of opportunity, loss of goodwill, loss or
              corruption of data or any other type of economic loss, injury or
              damage) or otherwise. The limitations and exclusions in this
              paragraph only apply to the extent permitted by applicable law.
            </p>

            <p>
              <strong>CONTACT US</strong>
            </p>

            <p>
              If you wish to contact us in relation to these terms and
              conditions, please contact us at: Informa Connect – Legal
              Department, 5 Howick Place, London, SW1P 1WG, UK / +44 (0) 20 7017
              5000.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

TermsAndConditions.propTypes = {
  brand: PropTypes.shape({
    primaryColor: PropTypes.string,
  }),
};
